import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e86c768"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "space"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Estaciones", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Parámetros", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Desde", -1))
const _hoisted_5 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Hasta", -1))
const _hoisted_8 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "card-header"
}
const _hoisted_11 = {
  key: 0,
  style: {"font-style":"italic"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_ctx.dataCollection !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_card, { class: "header-import page-title" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("menu.graphData")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 10,
          class: "space"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 6,
              class: "space"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, { class: "flexcol space" }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_el_select, {
                      onChange: _ctx.getStationsData,
                      class: "input",
                      modelValue: _ctx.selectedStations,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStations) = $event)),
                      multiple: "",
                      placeholder: "Estaciones",
                      "value-key": "id",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"]),
                    _hoisted_3,
                    _createVNode(_component_el_select, {
                      class: "input",
                      onChange: _ctx.getStationsData,
                      modelValue: _ctx.selectedParameters,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedParameters) = $event)),
                      multiple: "",
                      filterable: "",
                      placeholder: "Parámetros",
                      "filter-method": _ctx.filterParams
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            key: group.label,
                            label: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue", "filter-method"]),
                    _hoisted_4,
                    (_openBlock(), _createBlock(_component_el_date_picker, {
                      style: {"width":"100%"},
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event)),
                      type: "datetime",
                      placeholder: "DD/MM/AAAA hh:mm",
                      "default-time": _ctx.startDate,
                      clearable: true,
                      onChange: _ctx.getStationsData,
                      format: "YYYY-MM-DD HH:mm",
                      key: _ctx.dateKey
                    }, {
                      default: _withCtx((cell) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["cell", { current: cell.isCurrent }])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                          }, _toDisplayString(cell.text), 3),
                          (_ctx.hasEstimatedData(cell.date))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "default-time", "onChange"])),
                    _hoisted_6,
                    _hoisted_7,
                    (_openBlock(), _createBlock(_component_el_date_picker, {
                      style: {"width":"100%"},
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                      type: "datetime",
                      placeholder: "DD/MM/AAAA hh:mm",
                      "default-time": _ctx.endDate,
                      clearable: true,
                      onChange: _ctx.getStationsData,
                      format: "YYYY-MM-DD HH:mm",
                      key: _ctx.dateKey
                    }, {
                      default: _withCtx((cell) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["cell", { current: cell.isCurrent }])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                          }, _toDisplayString(cell.text), 3),
                          (_ctx.hasEstimatedData(cell.date))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "default-time", "onChange"])),
                    _hoisted_9,
                    (_ctx.selectedParameters.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Leyenda"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedParameters, (param) => {
                      return (_openBlock(), _createElementBlock("div", { key: param }, [
                        _createElementVNode("span", {
                          class: "legend-square",
                          style: _normalizeStyle({
                color: _ctx.parameters
                  .map((sets) => sets.options)
                  .flat()
                  .find((parameter) => parameter.value === param)?.color,
              })
                        }, "■ ", 4),
                        _createElementVNode("span", null, _toDisplayString(_ctx.parameters
                  .map((sets) => sets.options)
                  .flat()
                  .find((parameter) => parameter.value === param)?.label), 1),
                        (param === 'optical_operation' || param === 'state_SD' || param === 'capture')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 1: Correcto, 0: Incorrecto "))
                          : _createCommentVNode("", true),
                        _hoisted_12
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.selectedParameters.length > 0)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 18,
                  class: "graph-grid"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedStations, (station) => {
                      return (_openBlock(), _createBlock(_component_el_card, {
                        class: "graph-card",
                        key: station
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(station.name), 1),
                          (station.id && _ctx.dataCollection && _ctx.dataCollection[station.id])
                            ? (_openBlock(), _createBlock(_component_LineChart, {
                                key: 0,
                                "chart-data": _ctx.dataCollection[station.id],
                                options: _ctx.options
                              }, null, 8, ["chart-data", "options"]))
                            : _createCommentVNode("", true),
                          (!station.id || !_ctx.dataCollection[station.id])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("warning.notData")), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}